export const submissionTypes = ['resourceURL', 'resourceFile'];
